/* Mix & Match price examples follow the selected variant. Checkout owns final discounts. */
(() => {
  'use strict';
  if (customElements.get('evira-stack')) return;
  customElements.define('evira-stack', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      document.addEventListener('evira:variant:change', event => {
        if (event.detail?.variant?.price != null && event.target === document) {
          this.dataset.price = event.detail.variant.price;
          this.reprice();
        }
      }, {signal:this.controller.signal});
      this.reprice();
    }
    disconnectedCallback() { this.controller?.abort(); }
    reprice() {
      const price = Number(this.dataset.price || 0);
      const format = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style:'currency', currency:this.dataset.currency || window.Shopify?.currency?.active || 'GBP'
      });
      const money = cents => format.format(cents / 100);
      this.querySelectorAll('[data-qty]').forEach(row => {
        const qty = Number(row.dataset.qty), pct = Number(row.dataset.pct);
        const original = price * qty;
        const total = Math.round(original * (100 - pct) / 100);
        row.querySelector('[data-bundle-each]').textContent = money(Math.round(total / qty));
        row.querySelector('[data-bundle-total]').textContent = money(total);
        row.querySelector('[data-bundle-original]').textContent = money(original);
      });
    }
  });
})();
